import { render } from "./AdminYellowBanner.vue?vue&type=template&id=2ee2d3c8"
import script from "./AdminYellowBanner.vue?vue&type=script&lang=js"
export * from "./AdminYellowBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__